module.exports = __webpack_public_path__ + "resources/img/img-secuve-tos-04-m-en.4870d6f6af7181a50abb40f8dab586cd.png";